// extracted by mini-css-extract-plugin
export default {"banner":"AlertBanner_banner__nw-bS","danger":"AlertBanner_danger__fGSUO"};